import { CoreModal, CoreTextField } from "@verity/components/core";
import i18n from "../../../../../i18n";
import { Typography } from "@mui/material";
import { useEffect, useId, useState } from "react";
import apiClient from "../../../../../helpers/api-client";

type SendEmailModalProps = {
	onClose: () => void;
	onSend: (email: string, name: string) => Promise<void> | void;
};

export default function SendEmailModal({ onClose, onSend }: SendEmailModalProps) {
	const fullNameId = useId();
	const emailId = useId();
	const [userEnteredEmail, setUserEnteredEmail] = useState("");
	const [userEnteredName, setUserEnteredName] = useState("");

	useEffect(() => {
		void (async () => {
			try {
				const accountUserId = await apiClient.user.getUserId();
				const accountUserInfo = await apiClient.user.getUserInfo(accountUserId);
				setUserEnteredEmail(accountUserInfo?.userInfo.email ? accountUserInfo?.userInfo.email : "");
				setUserEnteredName(accountUserInfo?.userInfo.email ? accountUserInfo?.userInfo.full_name : "");
			} catch (err) {
				console.error(err);
			}
		})();
	}, []);

	return (
		<CoreModal
			maxWidth="min(90%, 600px)"
			open
			onClose={onClose}
			title={i18n.t("result.components.resultsPage.proctoringResultsViewTSX.emailRecording")}
			buttons={[
				{
					text: i18n.t("result.components.resultsPage.proctoringResultsViewTSX.cancel"),
					color: "secondary",
					onClick: onClose,
				},
				{
					text: i18n.t("result.components.resultsPage.proctoringResultsViewTSX.send"),
					color: "primary",
					onClick: async () => {
						onClose();
						await onSend(userEnteredEmail, userEnteredName);
					},
				},
			]}
		>
			<div>
				<Typography>{i18n.t("result.components.resultsPage.proctoringResultsViewTSX.receiverInfoTxt")}</Typography>

				<div style={{ marginTop: "10px" }}>
					<Typography
						id={fullNameId}
						style={{
							fontSize: "15px",
							lineHeight: "24.38px",
							color: "black",
							marginBottom: "10px",
							fontWeight: "bold",
						}}
					>
						{i18n.t("result.components.resultsPage.proctoringResultsViewTSX.fullName")}
					</Typography>
					<CoreTextField
						required
						sx={{ width: "100%" }}
						type="name"
						inputProps={{ "aria-labelledby": fullNameId }}
						value={userEnteredName}
						onChange={(e) => {
							setUserEnteredName(e.target.value);
						}}
					/>
				</div>
				<div style={{ marginTop: "10px" }}>
					<Typography
						id={emailId}
						style={{
							fontSize: "15px",
							lineHeight: "24.38px",
							color: "black",
							marginBottom: "10px",
							fontWeight: "bold",
						}}
					>
						{i18n.t("result.components.resultsPage.proctoringResultsViewTSX.email")}
					</Typography>
					<CoreTextField
						required
						sx={{ width: "100%" }}
						type="email"
						inputProps={{ "aria-labelledby": emailId }}
						value={userEnteredEmail}
						onChange={(e) => {
							setUserEnteredEmail(e.target.value);
						}}
					/>
				</div>
			</div>
		</CoreModal>
	);
}
